import locale from '../locale.json';
import { useResourceTabsStyles } from './ResourceTabs.styles';
import { ResourceTab, TAB_ALL, TAB_EBOOK, TAB_GAME } from '../utils/resourceGroups';

type ResourceTabsProps = {
  activeTab: ResourceTab;
  onChange: (tab: ResourceTab) => void;
};

const tabs = [
  { id: TAB_ALL, label: locale.tabAll },
  { id: TAB_EBOOK, label: locale.tabEbook },
  { id: TAB_GAME, label: locale.tabSeriousGame },
];

const ResourceTabs = ({ activeTab, onChange }: ResourceTabsProps) => {
  const classes = useResourceTabsStyles();

  return (
    <div className={classes.tabsWrapper}>
      <div className={classes.tabsRow}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={activeTab === tab.id ? classes.tabActive : classes.tab}
            onClick={() => onChange(tab.id as ResourceTab)}>
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ResourceTabs;
